import {
  Text,
  useDisclosure,
  HStack,
} from '@chakra-ui/react';
import { shallow } from 'zustand/shallow';
import { useUIStore } from '#store';
import { getCancellationView } from '../../utils/cancellationView.js';
import ConfidencePanel from '../Tracker/ConfidencePanel.jsx';

/**
 * Inline cancellation-stats trigger for TripBuilder (drawer-safe; no absolute
 * NewsBar animation). Reuses the same store analytics + ConfidencePanel.
 */
export default function TripStatsBanner() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const news = useUIStore((state) => state.news, shallow);
  const view = getCancellationView(news);

  if (!view) return null;

  const displayText = view.isLast30Days
    ? `${view.totalSpots.toLocaleString('en-US')} cancellations in the last 30 days`
    : `${view.totalSpots.toLocaleString('en-US')} cancellations detected`;

  return (
    <>
      <HStack
        w="100%"
        py={1.5}
        px={3}
        bg="orange.50"
        borderWidth="1px"
        borderColor="orange.200"
        borderRadius="md"
        color="orange.800"
        fontSize="sm"
        fontWeight={500}
        justify="space-between"
        cursor="pointer"
        onClick={onOpen}
        _hover={{ bg: 'orange.100' }}
        transition="background 0.15s"
      >
        <Text noOfLines={1}>{displayText}</Text>
        <Text as="span" textDecoration="underline" fontWeight={600} flexShrink={0}>
          See stats →
        </Text>
      </HStack>
      <ConfidencePanel isOpen={isOpen} onClose={onClose} />
    </>
  );
}
